export default "__VITE_ASSET__DmTKZ7EB__";